import React, { forwardRef } from "react";

import { RECIPIENTS } from "./constants";

const MailTo = forwardRef(({ recipient, content, ...rest }, ref) => (
  <a
    href={`mailto:${recipient}`}
    className="program-link text-decoration-none"
    target="_blank"
    rel="noreferrer"
    ref={ref}
    {...rest}
  >
    {content || recipient}
  </a>
));

export const MailToConcierge = ({ ...props }) => (
  <MailTo recipient={RECIPIENTS.concierge} {...props} />
);

export const MailToPurchasing = ({ ...props }) => (
  <MailTo recipient={RECIPIENTS.purchasing} {...props} />
);

export const MailToBrands = ({ ...props }) => <MailTo recipient={RECIPIENTS.brands} {...props} />;

export const MailToRestaurants = ({ ...props }) => (
  <MailTo recipient={RECIPIENTS.restaurants} {...props} />
);

export const MailToShop = ({ ...props }) => <MailTo recipient={RECIPIENTS.shops} {...props} />;
export default MailTo;
